<ion-card
  button="true"
  (click)="showFastpayRequestModalInParent()"
>
  <ion-card-header mode="ios">
    <ion-card-title color="white">
      {{
        'fast_pay.request_fast_pay_cta_freight' | translate: { priceWithDiscount: priceWithDiscount | number: '1.2-2' }
      }}
    </ion-card-title>
  </ion-card-header>
  <ion-card-content class="ion-text-end">
    <ion-button color="white">{{ 'fast_pay.view_conditions_and_request' | translate }}</ion-button>
  </ion-card-content>
</ion-card>
